export default __webpack_public_path__ + "static/spett2-c0b299d68e690837720424827b395d27.png";